export { WlxTabComponent as TabComponent } from './tab.component';
export { WlxTabsComponent as TabsComponent } from './tabs.component';
export { WlxTabViewComponent as TabViewComponent } from './tab-view.component';
export { TabWellContentViewDirective } from './tab-well-content-view.directive';
export { LazyTabContentDirective } from './lazy-tab-content.directive';
